// QuizQuestions.js
import React, { useState } from "react";

export default function QuizQuestions({
  question,
  onAnswerSelect,
  number,
  quizReadOnly,
}) {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionSelect = (optionIndex) => {
    setSelectedOption(optionIndex);
    onAnswerSelect(
      question?._id,
      question?.image,
      question?.question,
      question?.options[optionIndex]
    );
  };
  return (
    <div className="mt-[20px]">
      <p className="font-medium text-[#cdcdcd]">Question {number + 1}</p>
      {question?.image && (
        <div className="h-[320px] h-auto w-[100%] overflow-hidden flex items-start justify-center mb-[15px] bg-[#1c1c1c]">
          <img
            src={question?.image}
            alt="Question"
            className=" outline-none w-auto h-[100%] object-contain"
          />
        </div>
      )}

      <p className="text-[#cdcdcd]"> {question?.question}</p>
      <div className="mt-[10px] w-full">
        {question?.options.map((option, index) => (
          <div key={index} className="flex w-full items-center ">
            <label
              htmlFor={`option-${question?._id}-${index}`}
              className="w-[50%] text-[#cdcdcd] cursor-pointer py-[8px]"
            >
              {index + 1}. {option}
            </label>
            <input
              type="radio"
              name={`mcq-option-${question?._id}`}
              id={`option-${question?._id}-${index}`}
              checked={selectedOption === index}
              onChange={() => (quizReadOnly ? "" : handleOptionSelect(index))}
              className="cursor-pointer h-[15px] w-[15px]"
            />
          </div>
        ))}
      </div>
    </div>
  );
}
